
import Vue from "vue";
import { LabelLayout } from "@/utils/label-layout/label-layout";
import { LayoutEditorEventBus } from "../layout-editor/layout-editor-event-bus";
import AppTextBlock from "./TextBlock.vue";
import { Model } from "@/utils/models/model";
import AppBarcode from "./Barcode.vue";
import AppQrCode from "./QrCode.vue";
import AppImage from "./Image.vue";

export default Vue.extend({
	props: {
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		},
		zoomLevel: Number,
	},
	computed: {
		dragging():boolean {
			return LayoutEditorEventBus.dragging;
		},
		width(): number {
			return this.layout.PageSettings.Width;
		},
		height(): number {
			return this.layout.PageSettings.Height;
		},
		transform(): string {
			let val = this.zoomLevel / 100.0;
			return `scale(${val})`;
		},
		minRootWidth(): string {
			let val = (this.width * this.zoomLevel) / 100.0;
			return `${val}mm`;
		},
		minRootHeight(): string {
			let val = (this.height * this.zoomLevel) / 100.0;
			return `${val}mm`;
		},
		pageStyle(): Object {
			return {
				width: this.width + "mm",
				height: this.height + "mm",
				transform: this.transform,
				transformOrigin: "top center",
			};
		},
		innerContainerStyle():Object {
			return {
				width: this.width + "mm",
				height: this.height + "mm",
			};
		},
		model():Model{
			return this.layout.getModel();
		}
	},
	watch: {
		zoomLevel: {
			immediate: true,
			handler(zoomLevel: number) {
				LayoutEditorEventBus.zoomLevel = zoomLevel / 100.0;
			}
		}
	},
	methods: {
		onMouseMove(event: MouseEvent) {
			event.preventDefault();
			event.stopPropagation();
			LayoutEditorEventBus.mouseMove(event.clientX, event.clientY);
		},
		onMouseUp(event: MouseEvent) {
			if (event.button == 0) {
				LayoutEditorEventBus.mouseUp();
			}
		}
	},
	created(){
		window.addEventListener("mouseup", this.onMouseUp);
	},
	destroyed(){
		window.removeEventListener("mouseup", this.onMouseUp);
	},
	components: {
		AppTextBlock,
		AppBarcode,
		AppQrCode,
		AppImage
	}
});
